



















import { defineComponent, PropType } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import ALink from '@/components/common/a-link/a-link.vue';
import { i18n } from './../../../../i18n';

const name = 'ttam-ad-text-label';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    title: {
      type: String,
      default: () => i18n.t('ad_text'),
    },
  },
  setup() {
    return {
      name,
    };
  },
});
